<h4 [innerHTML]="profileNarrowingsText.subheading"></h4>
<ul class="id37-text2 text-light">
  <li *ngFor="let bulletPoint of profileNarrowingsText.bulletPointTexts" [innerHTML]="bulletPoint"></li>
</ul>
